import PropTypes from 'prop-types'

import { ReactComponent as GolferIcon } from '../../../assets/images/common/icons/golfer-half-icon.svg'
import { ReactComponent as FlagIcon } from '../../../assets/images/common/icons/weavy-flag-icon.svg'
import { ReactComponent as GroupIcon } from '../../../assets/images/common/icons/users-group-icon.svg'
import AccountSegmentCard from './AccountSegmentCard'

const COACH_FORM_URL =
  'https://share.hsforms.com/18DFr5TiZRhef_vcDS9dWYAqm7oy?utm_source=op36app&utm_medium=registrationform&utm_campaign=openexperience'

const AccountSegmentSelector = ({ onIndividualClick, onFamilyClick, showHeaders, wrapperClassName, cardClassName }) => {
  const handleCoachClick = () => {
    const isProduction = process.env.NODE_ENV === 'production' && process.env.REACT_APP_BASE_URL === 'https://operation36golf.com'

    if (!isProduction) {
      alert('Disabled (Not in production)') // eslint-disable-line no-alert
      return
    }

    window.location.href = COACH_FORM_URL
  }

  return (
    <>
      <div className={wrapperClassName}>
        <AccountSegmentCard
          icon={GolferIcon}
          title="I'm signing myself up"
          description="I'm creating this account for myself and my golf journey."
          onClick={onIndividualClick}
          showHeader={showHeaders}
          headerText='For Individuals'
          className={cardClassName}
        />
      </div>

      <div className={wrapperClassName}>
        <AccountSegmentCard
          icon={GroupIcon}
          title='I may be signing up my kids or myself for programs'
          description="I'm creating this account to manage my family."
          onClick={onFamilyClick}
          showHeader={showHeaders}
          headerText='For Families'
          className={cardClassName}
        />
      </div>

      <div className={wrapperClassName}>
        <AccountSegmentCard
          icon={FlagIcon}
          title="I'm a Golf Professional"
          description="I'm creating this account to explore the Op 36 App."
          onClick={handleCoachClick}
          showHeader={showHeaders}
          headerText='For Coaches'
          className={cardClassName}
        />
      </div>
    </>
  )
}

AccountSegmentSelector.propTypes = {
  onIndividualClick: PropTypes.func.isRequired,
  onFamilyClick: PropTypes.func.isRequired,
  showHeaders: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  cardClassName: PropTypes.string,
}

export default AccountSegmentSelector
